import get from 'lodash.get';
import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { mapScaleToPeriodResolution } from '~/modules/resourcing/common/util';
import { useHasFeatureFlag } from '~/modules/common/hooks';

export const RESOURCE_ACTUAL_SERIES_BY_PROJECT_QUERY = gql`
  query getResourceUserActualSeriesByProject(
    $page: Int!
    $pageSize: Int!
    $dateRange: DateRangeInput!
    $periodResolution: PeriodResolutionOption!
    $projectUri: String!
    $sort: ActualSort
  ) {
    resourceUserActualSeriesByProject(
      page: $page
      pageSize: $pageSize
      dateRange: $dateRange
      periodResolution: $periodResolution
      projectUri: $projectUri
      sort: $sort
    ) {
      user {
        id
        displayText
      }
      project {
        id
        displayText
      }
      role {
        id
        displayText
      }
      periods {
        emptyPeriodInFuture
        hours {
          hours
          minutes
          seconds
        }
        cost {
          amount
          currency {
            id
            uri
            displayText
            symbol
          }
        }
        dateRange {
          startDate: startDate2
          endDate: endDate2
        }
      }
    }
  }
`;

export const useResourceActualSeriesByProject = ({
  page = 1,
  pageSize = 200,
  dateRange,
  scale,
  projectUri,
  sort,
  isResourceActualModeEnabled = false
}) => {
  const isPSARMPResourceActualEnabled = useHasFeatureFlag({
    featureFlag: 'isPSARMPResourceActualEnabled'
  });
  const { data, loading } = useQuery(RESOURCE_ACTUAL_SERIES_BY_PROJECT_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      page,
      pageSize,
      dateRange,
      periodResolution: mapScaleToPeriodResolution(scale),
      projectUri,
      sort
    },
    skip: !(isPSARMPResourceActualEnabled && isResourceActualModeEnabled)
  });

  const resourceUserActualSeries = get(
    data,
    'resourceUserActualSeriesByProject',
    []
  );

  return {
    isLoading: loading,
    resourceUserActualSeries
  };
};

export default useResourceActualSeriesByProject;
